import { type EntitiesMatches } from '../../../states/entities/matches';
import { type EntitiesMatchesEntityHallOfFameBetslipsState } from '../../../states/entities/matches';
import { type MatchState } from '../../../states/entities/matches';
import type { StateType } from '../../../states/index';
import { type Highlight } from '../../../types/match';
import { type Scorer } from '../../../types/match';
import { type MatchStatus } from '../../../types/match';
import { PeriodId } from '../../../types/periodIds';
import { type Selector } from '../../../types/selectors';
import { type SportId } from '../../../types/sports';
import { type TopMyMatch } from '../../../types/topMyMatch';
import { getMatchIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};
const emptyArray: [] = [];

export const selectEntitiesMatches: Selector<EntitiesMatches> = (state: StateType) =>
  selectEntitiesState(state).matches ?? emptyObject;

//#region state.entities.matches
export type EntitiesMatchesSelectorProps = {
  matchId?: number;
};

export const selectEntitiesMatchesEntity: Selector<MatchState | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => {
  const matchId = getMatchIdFromProps(state, props);

  if (matchId) {
    return selectEntitiesMatches(state)[matchId];
  }
};
//#endregion

//#region state.entities.matches[matchId]
export const selectEntitiesMatchesEntityMatchId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchId;

export const selectEntitiesMatchesEntityMainBetId: Selector<number | undefined | null> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.mainBetId;

export const selectEntitiesMatchesEntityMoreBets: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.moreBets;

export const selectEntitiesMatchesEntityAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.available ?? false;

export const selectEntitiesMatchesEntityScore: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.score;

export const selectEntitiesMatchesEntityPeriod: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.period;

export const selectEntitiesMatchesEntityPeriodId: Selector<PeriodId | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.periodId;

export const selectEntitiesMatchesEntityPeriodName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.periodName;

export const selectEntitiesMatchesEntityHlType: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.hlType;

export const selectEntitiesMatchesEntityMatchtime: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchtime;

export const selectEntitiesMatchesEntityMatchtimeExtended: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchtimeExtended;

export const selectEntitiesMatchesEntityMymatchAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.mymatchAvailable ?? false;

export const selectEntitiesMatchesEntitySetScores: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.setScores;

export const selectEntitiesMatchesEntityStatus: Selector<MatchStatus | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.status;

export const selectEntitiesMatchesEntityTitle: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.title;

export const selectEntitiesMatchesEntityRoundName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.roundName;

export const selectEntitiesMatchesEntityTvChannels: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.tvChannels;

export const selectEntitiesMatchesEntitySportId: Selector<SportId | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.sportId;

export const selectEntitiesMatchesEntityCategoryId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.categoryId;

export const selectEntitiesMatchesEntityTournamentId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.tournamentId;

export const selectEntitiesMatchesEntityCompetitor1Id: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor1Id;

export const selectEntitiesMatchesEntityCompetitor1Name: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor1Name;

export const selectEntitiesMatchesEntityCompetitor1Flag: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor1Flag;

export const selectEntitiesMatchesEntityCompetitor2Id: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor2Id;

export const selectEntitiesMatchesEntityCompetitor2Name: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor2Name;

export const selectEntitiesMatchesEntityCompetitor2Flag: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.competitor2Flag;

export const selectEntitiesMatchesEntityMatchStart: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchStart;

export const selectEntitiesMatchesEntityMatchEnd: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchEnd;

export const selectEntitiesMatchesEntityRedCardsHome: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.redCardsHome;

export const selectEntitiesMatchesEntityRedCardsAway: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.redCardsAway;

export const selectEntitiesMatchesEntityYellowCardsAway: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.yellowCardsAway;

export const selectEntitiesMatchesEntityYellowCardsHome: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.yellowCardsHome;

export const selectEntitiesMatchesEntityYellowRedCardsAway: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.yellowRedCardsAway;

export const selectEntitiesMatchesEntityYellowRedCardsHome: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.yellowRedCardsHome;

export const selectEntitiesMatchesEntityBetradarHasStatistics: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.betradarHasStatistics ?? false;

export const selectEntitiesMatchesEntityStream: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.stream;

export const selectEntitiesMatchesEntityHasTracker: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.hasTracker ?? false;

export const selectEntitiesMatchesEntitySkillcornerId: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.skillcornerId;

export const selectEntitiesMatchesEntityExpectedT1: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.expectedT1;

export const selectEntitiesMatchesEntityExpectedT2: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.expectedT2;

export const selectEntitiesMatchesEntityBets: Selector<Array<number>> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.bets ?? emptyArray;

export const selectEntitiesMatchesEntityScorers: Selector<Array<Scorer>> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
  // $FlowFixMe
) => selectEntitiesMatchesEntity(state, props)?.scorers ?? emptyArray;

export const selectEntitiesMatchesEntityRemainingTime: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.remainingTime;

export const selectEntitiesMatchesEntityRemainingTimeInPeriod: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.remainingTimeInPeriod;

export const selectEntitiesMatchesEntityClockStopped: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.clockStopped ?? false;

export const selectEntitiesMatchesEntityServer: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.server;

export const selectEntitiesMatchesEntitySuspendHome: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.suspendHome ?? false;

export const selectEntitiesMatchesEntitySuspendAway: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.suspendAway ?? false;

export const selectEntitiesMatchesEntitySrSeasonId: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.srSeasonId;

export const selectEntitiesMatchesEntitySrTournamentId: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.srTournamentId;

export const selectEntitiesMatchesEntityStageId: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.stageId;

export const selectEntitiesMatchesEntityParentStageId: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.parentStageId;

export const selectEntitiesMatchesEntityIsOutright: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.isOutright ?? false;

export const selectEntitiesMatchesEntityMatchPromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchPromo;

export const selectEntitiesMatchesEntityMatchWarning: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.matchWarning;

export const selectEntitiesMatchesEntityAtAtInvalid: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.['@@invalid'] ?? false;

export const selectEntitiesMatchesEntityFilters: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.filters;

export const selectEntitiesMatchesEntityMultimatch: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.multimatch;

export const selectEntitiesMatchesEntityListBetIds: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.listBetIds;

export const selectEntitiesMatchesEntityIsCancelled: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.isCancelled ?? false;

export const selectEntitiesMatchesEntityImg: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.img;

export const selectEntitiesMatchesEntityTopMymatchs: Selector<Array<TopMyMatch> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.topMymatchs;

export const selectEntitiesMatchesEntityLineupsAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.lineupsAvailable ?? false;

export const selectEntitiesMatchesEntityStreamHighlightsAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.streamHighlightsAvailable ?? false;

export const selectEntitiesMatchesEntityStreamHighlightsAvailableUntil: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.streamHighlightsAvailableUntil;

export const selectEntitiesMatchesEntityHighlights: Selector<Array<Highlight> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.highlights;

export const selectEntitiesMatchesEntitySubmatches: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.submatches;

export const selectEntitiesMatchesEntityStoppageTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.stoppageTime;

export const selectEntitiesMatchesEntityStoppageTimeAnnounced: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.stoppageTimeAnnounced;

export const selectEntitiesMatchesEntitySummaryComputed: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.summaryComputed ?? false;

export const selectEntitiesMatchesEntityFieldImg: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.fieldImg;

export const selectEntitiesMatchesEntityOfficialLineups: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.officialLineups ?? false;

export const selectEntitiesMatchesEntityIsPrivateScore: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.isPrivateScore ?? false;

export const selectEntitiesMatchesEntityImgEventId: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.imgEventId;

export const selectEntitiesMatchesEntityImgFightId: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.imgFightId;

export const selectEntitiesMatchesEntityHotPeriod: Selector<number | null | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.hotPeriod;

export const selectEntitiesMatchesEntityHallOfFameBetslips: Selector<
  EntitiesMatchesEntityHallOfFameBetslipsState | undefined
> = (state: StateType, props: EntitiesMatchesSelectorProps = {}) =>
  selectEntitiesMatchesEntity(state, props)?.hallOfFameBetslips;

export const selectEntitiesMatchesEntityStartingOrdersAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.startingOrdersAvailable ?? false;

export const selectEntitiesMatchesEntityTotalRaceLaps: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.totalRaceLaps;

export const selectEntitiesMatchesEntityCurrentRaceLap: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntity(state, props)?.currentRaceLap;
//#endregion

//#region state.entities.matches[matchId].hallOfFameBetslips
export const selectEntitiesMatchesEntityHallOfFameBetslipsBiggestCombo: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntityHallOfFameBetslips(state, props)?.biggestCombo;

export const selectEntitiesMatchesEntityHallOfFameBetslipsBiggestMymatch: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntityHallOfFameBetslips(state, props)?.biggestMymatch;

export const selectEntitiesMatchesEntityHallOfFameBetslipsBiggestOdds: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntityHallOfFameBetslips(state, props)?.biggestOdds;

export const selectEntitiesMatchesEntityHallOfFameBetslipsBiggestWinningsSimple: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesMatchesSelectorProps = {},
) => selectEntitiesMatchesEntityHallOfFameBetslips(state, props)?.biggestWinningsSimple;
//#endregion
